'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepAssign = require('deep-assign');

var _deepAssign2 = _interopRequireDefault(_deepAssign);

require('./utils/polyfills');

var _BeaconEntryQueue = require('./utils/BeaconEntryQueue');

var _BeaconEntryQueue2 = _interopRequireDefault(_BeaconEntryQueue);

var _dynamicEventHelper = require('./utils/dynamicEventHelper');

var _initClientProfilerEvents = require('./utils/initClientProfilerEvents');

var _sendBeacon2 = require('./utils/sendBeacon');

var _performanceEntryUtils = require('./utils/performanceEntryUtils');

var _formatTiming = require('./utils/formatTiming');

var _BrowserTimings = require('./utils/BrowserTimings');

var _setAppInfo = require('./utils/setAppInfo');

var _setAppInfo2 = _interopRequireDefault(_setAppInfo);

var _package = require('../package.json');

var _package2 = _interopRequireDefault(_package);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_APP_CONFIG = {
    // app configuration
    enableBeaconing: true,
    pageLoadBeaconDelay: 3000,
    sendBeaconOverride: null,

    // event info
    eventNameMap: null,
    eventThresholds: null,

    // static data to include with every beacon, e.g., page name, environment, build hash, etc.
    staticBeaconData: {
        pageName: 'UNKNOWN'
    }
};

var ClientProfiler = function () {
    function ClientProfiler(initAppConfig) {
        var _this = this;

        _classCallCheck(this, ClientProfiler);

        (0, _setAppInfo2.default)(_package2.default.name, '2e504d1');

        this.appConfig = (0, _deepAssign2.default)({}, DEFAULT_APP_CONFIG, initAppConfig);

        this.beaconFrom = 0;
        this.staticEntryQueue = new _BeaconEntryQueue2.default();
        this.dynamicEntryQueue = new _BeaconEntryQueue2.default();
        this.navigationTimings = new _BrowserTimings.NavigationTimings();
        this.resourceTimings = new _BrowserTimings.ResourceTimings();

        ['clearAllBeaconHistory', 'getPerformanceEntries', 'getProfiles', 'profile', 'profileIntervalBegin', 'profileIntervalEnd', 'profileIntervalFail', 'sendBeacon', 'sendLoadBeacon'].forEach(function (method) {
            _this[method] = _this[method].bind(_this);
        });

        if (this.appConfig.enableBeaconing) {
            (0, _initClientProfilerEvents.initClientProfilerEvents)(this.sendBeacon, this.sendLoadBeacon);
        }
    }

    _createClass(ClientProfiler, [{
        key: 'sendBeacon',
        value: function sendBeacon() {
            var _appConfig = this.appConfig,
                beaconUrl = _appConfig.beaconUrl,
                eventNameMap = _appConfig.eventNameMap,
                eventThresholds = _appConfig.eventThresholds,
                sendBeaconOverride = _appConfig.sendBeaconOverride,
                staticBeaconData = _appConfig.staticBeaconData;

            var profiles = this.getProfiles();
            if (profiles.length > 0) {
                (sendBeaconOverride || _sendBeacon2.sendBeacon)({
                    beaconUrl: beaconUrl,
                    eventNameMap: eventNameMap,
                    eventThresholds: eventThresholds,
                    profiles: profiles,
                    staticBeaconData: staticBeaconData
                });
            }
        }
    }, {
        key: 'sendLoadBeacon',
        value: function sendLoadBeacon() {
            this.profile('loaded ' + this.appConfig.staticBeaconData.pageName);
            setTimeout(this.sendBeacon, this.appConfig.pageLoadBeaconDelay);
            this.profile('onload completed');
        }
    }, {
        key: 'profile',
        value: function profile(eventName) {
            var isDynamicEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!isDynamicEvent && !(0, _performanceEntryUtils.getPerformanceEntriesByName)(eventName).length) {
                this.staticEntryQueue.queueBeaconEntry(eventName);
                window.performance.mark(eventName);
            } else if (isDynamicEvent) {
                this.dynamicEntryQueue.queueBeaconEntry(eventName);
                window.performance.mark(eventName);
            }
        }
    }, {
        key: 'profileIntervalBegin',
        value: function profileIntervalBegin(eventName) {
            this.profile(eventName, true);
        }
    }, {
        key: 'profileIntervalEnd',
        value: function profileIntervalEnd(eventName) {
            (0, _dynamicEventHelper.dynamicEventHelper)(eventName, true, this.dynamicEntryQueue.queueBeaconEntry);
        }
    }, {
        key: 'profileIntervalFail',
        value: function profileIntervalFail(eventName) {
            (0, _dynamicEventHelper.dynamicEventHelper)(eventName, false, this.dynamicEntryQueue.queueBeaconEntry);
        }

        /**
         * Retrieve all profiles corresponding PerformanceEntry
         * @returns {PerformanceEntry[]}
         */

    }, {
        key: 'getPerformanceEntries',
        value: function getPerformanceEntries() {
            // Get static profiles
            var staticEntryNames = [].concat(this.staticEntryQueue.getBeaconEntryQueue());

            // Get dynamic profiles
            var dynamicEntryNames = [].concat(this.dynamicEntryQueue.getBeaconEntryQueue());

            // Get static profile performance entries
            var staticPerformanceEntries = staticEntryNames.reduce(function (acc, name) {
                return [].concat(acc, (0, _performanceEntryUtils.getPerformanceEntriesByName)(name));
            }, []);

            // Get dynamic profile performance entries
            var dynamicPerformanceEntries = dynamicEntryNames.reduce(function (acc, name) {
                return [].concat(acc, (0, _performanceEntryUtils.getPerformanceEntriesByName)(name));
            }, []);

            var performanceEntries = [].concat(staticPerformanceEntries, dynamicPerformanceEntries);

            // Clear out dynamic performance entries that are about to be reported
            // only. The dynamic in's performance mark is needed to measure
            // duration when it ends.
            (0, _dynamicEventHelper.getCompletedDynamicEvents)(dynamicPerformanceEntries).forEach(_performanceEntryUtils.clearPerformanceMeasure);

            return performanceEntries;
        }

        /**
         * Clears all profiles and their corresponding PerformanceEntry objects
         * @returns {undefined}
         */

    }, {
        key: 'clearAllBeaconHistory',
        value: function clearAllBeaconHistory() {
            this.staticEntryQueue.clearBeaconEntryQueue();
            this.dynamicEntryQueue.clearBeaconEntryQueue();
        }

        /**
         * Get all profiled events for beacon
         * @returns {String[]}
         */

    }, {
        key: 'getProfiles',
        value: function getProfiles() {
            var entries = this.getPerformanceEntries();

            // Retrieve navigationTimings and append to profiles array
            var navigationTimings = (0, _formatTiming.objectToTimingArray)(this.navigationTimings.pop());
            var fullyLoadedTime = (0, _formatTiming.objectToTimingArray)(this.resourceTimings.getFullyLoadedTimeOnce());

            var profiles = entries.map(_performanceEntryUtils.formatPerformanceEntry).concat(navigationTimings).concat(fullyLoadedTime);

            // Clear beacon entry queues for next call.
            this.clearAllBeaconHistory();

            return profiles;
        }
    }, {
        key: 'appConfig',
        set: function set(appConfig) {
            this.internalAppConfig = (0, _deepAssign2.default)({}, this.internalAppConfig, appConfig);
        },
        get: function get() {
            return this.internalAppConfig;
        }
    }]);

    return ClientProfiler;
}();

exports.default = ClientProfiler;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/ClientProfiler.js
// module id = 491
// module chunks = 4